module.exports = __webpack_public_path__ + "img/DW365-128.90fd2cf0.jpg";